export const pages = [
  {
    name: "Cream Gel",
    link: "/gel-polish/cream-gel",
    images: {
      x1: "/images/page/recommended/cream_gel_page.webp",
      x2: "/images/page/recommended/cream_gel_page@2x.webp",
      x3: "/images/page/recommended/cream_gel_page@3x.webp",
    }
  },
  {
    name: "Cat Eye",
    link: "/collections/cat-eye",
    images: {
      x1: "/images/page/recommended/20512-RCM-Magnet-AstroFlash-GalacticCowgirl-HandGlam2-Photo-4.webp",
      x2: "/images/page/recommended/20512-RCM-Magnet-AstroFlash-GalacticCowgirl-HandGlam2-Photo-4@2x.webp",
      x3: "/images/page/recommended/20512-RCM-Magnet-AstroFlash-GalacticCowgirl-HandGlam2-Photo-4@3x.webp",
    }
  },
  {
    name: "Astro Flash",
    link: "/collections/astro-flash",
    images: {
      x1: "/images/page/recommended/astro_flash.webp",
      x2: "/images/page/recommended/astro_flash@2x.webp",
      x3: "/images/page/recommended/astro_flash@3x.webp",
    }
  }
]